import React from "react"
import styled from "styled-components"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import { theme } from "./mixin"

export default function Button({
  secondary,
  onClick,
  content,
  arrow,
  href,
  blank,
  id,
  disable
}) {
  return (
    <a href={href} target={blank ? "_blank" : "_self"} id={id} rel="noreferrer">
      <Wrapper
        className={`${secondary ? "secondary" : "primary"} ${
          disable ? "disable" : ""
        }`}
        border={`3px solid`}
        onClick={onClick}
      >
        {content}
        {arrow && <ArrowForwardIosIcon />}
      </Wrapper>
    </a>
  )
}

const Wrapper = styled.div`
  font-family: "Arial";
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 13px 29px;
  min-width: 160px;
  border-radius: 99999px;
  font-size: 20px;
  font-weight: bold;
  transition: all 0.3s;
  line-height: 1.2;
  flex-wrap: nowrap;
  cursor: pointer;
  font-family: ${theme.titleFonts};

  white-space: nowrap;

  transition: 0.5s;
  &.primary {
    color: ${theme.white};
    background-size: 300% 100%;
    background-position: 98% 0;
    background-image: ${theme.CTAcolorButton};
    border: 1px solid transparent;
  }
  &.secondary {
    background: ${theme.white};
    border: 1px solid ${theme.CTAcolor};
    color: ${theme.CTAcolor};
    &.disable {
      cursor: default;
      &:hover {
        transform: scale(1);
        box-shadow: none;
      }
    }
  }

  &:hover {
    background-position: 0% 0;
    transform: scale(1.05);
    box-shadow: 4px 8px 8px rgba(0, 0, 0, 0.1);
  }

  @media (${theme.xxl}) {
    font-size: 20px;
  }
  @media (${theme.lg}) {
    padding: 12px 24px;
    width: 100%;
    font-size: 20px;
  }
  @media (${theme.md}) {
    font-size: 16px;
    padding: 12px 24px;
    width: 100%;
  }
`
